import { Timezone } from '@/components/molecules/main-header/types';
import { TeamLeagueInfo } from '@/entities/TeamLeagueInfo';
import { TeamLeagueInfoDto } from '@/infrastructure/network/dto/TeamLeagueInfoDto';
import { DateUtil } from '@/utils/date';

export const teamLeagueInfoDtoToTeamLeagueInfo = (teamLeagueInfoDto: TeamLeagueInfoDto, timezones: Timezone[]): TeamLeagueInfo => {
	const timezone = timezones.find((tz) => +tz.id === teamLeagueInfoDto.timezoneId);
	const iana = timezone?.ianaTzIdentifier || 'UTC';
	const convert = (date?: string | null): Date | null => (date ? new Date(DateUtil.formatInTimezone(date, 'YYYY-MM-DDTHH:mm:ss', iana)) : null);

	return {
		...teamLeagueInfoDto,
		logo: {
			...teamLeagueInfoDto.logo,
			dateCreated: teamLeagueInfoDto?.logo?.dateCreated ? new Date(teamLeagueInfoDto.logo.dateCreated) : null,
			dateUpdated: teamLeagueInfoDto?.logo?.dateUpdated ? new Date(teamLeagueInfoDto.logo.dateUpdated) : null,
			dateDisabled: teamLeagueInfoDto?.logo?.dateDisabled ? new Date(teamLeagueInfoDto.logo.dateDisabled) : null
		},
		dateStart: convert(teamLeagueInfoDto.dateStart),
		dateEnd: convert(teamLeagueInfoDto.dateEnd),
		registrationDateOpen: convert(teamLeagueInfoDto.registrationDateOpen),
		registrationDateClose: convert(teamLeagueInfoDto.registrationDateClose),
		hideAllRegistrationInfo: teamLeagueInfoDto.hideAllRegistrationInfo,
		utcOffset: timezone?.utcOffset
	};
};
